import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

const FORM_ID = 'd9q853cnlsngrm4llt70';

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 成人导航',
    description: '成人导航致力于为广大用户提供最全面、最安全、最便捷的成人内容导航服务。',
    url: 'https://adultnav.example.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '成人导航',
      url: 'https://adultnav.example.com',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '成人导航',
    url: 'https://adultnav.example.com',
    description: '成人导航为您提供最全面的成人内容导航服务，精选优质成人网站、影视资源、娱乐平台一站式导航。',
    logo: 'https://adultnav.example.com/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@example.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '成人导航收录网站的筛选标准是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们有一套严格的筛选标准，包括网站内容质量、用户口碑、安全性、访问速度等多个维度。所有收录网站都经过人工审核，确保为用户提供安全可靠的导航服务。',
        },
      },
      {
        '@type': 'Question',
        name: '成人导航是否免费使用？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，成人导航完全免费。用户可以自由浏览所有分类和网站资源，无需支付任何费用。我们致力于为所有用户提供平等的优质导航服务。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向成人导航推荐新的网站资源？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过本页面的联系我们表单提交推荐。我们的编辑团队会对提交的网站进行审核，符合标准的网站将被收录到相应的分类中。',
        },
      },
      {
        '@type': 'Question',
        name: '使用成人导航是否安全？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '成人导航高度重视用户安全。我们不收集用户隐私信息，所有收录网站都经过安全检测。我们建议用户在浏览时也注意保护个人隐私，使用安全的网络环境。',
        },
      },
      {
        '@type': 'Question',
        name: '成人导航多久更新一次内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的编辑团队每日都会更新和审核收录的网站资源，确保信息的时效性和准确性。热门分类和推荐文章会保持较高的更新频率，为用户提供最新的内容推荐。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 成人导航"
        description="成人导航致力于为广大用户提供最全面、最安全、最便捷的成人内容导航服务。了解我们的品牌故事、发展历程与核心价值观。"
        keywords="成人导航,关于我们,成人导航介绍,成人内容导航平台,联系我们"
        canonicalUrl="/about"
        schemaData={{ ...aboutSchema, ...orgSchema, ...faqSchema }}
      />

      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main className="pt-20">
          <section className="px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-7xl mx-auto">
              <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-8 flex-wrap" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line text-[10px]"></i>
                <span className="text-foreground-300">关于我们</span>
              </nav>

              <div className="max-w-4xl mx-auto">
                <div className="text-center mb-12 md:mb-16">
                  <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center mx-auto mb-6">
                    <i className="ri-compass-3-fill text-3xl text-background-950"></i>
                  </div>
                  <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-50 mb-4">
                    关于成人导航
                  </h1>
                  <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                    成人导航成立于2024年，致力于为广大用户提供最全面、最安全、最便捷的成人内容导航服务。我们深知用户在寻找成人内容资源时面临的困惑与风险，因此我们精心筛选和整理了互联网上优质的成人网站和平台资源。
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-14 md:mb-20">
                  {[
                    { icon: 'ri-eye-line', title: '我们的愿景', desc: '成为最值得信赖的成人内容导航平台，为用户提供安全可靠的资源发现体验。' },
                    { icon: 'ri-flag-line', title: '我们的使命', desc: '帮助用户高效、安全地找到优质的成人内容资源，节省搜索时间，降低访问风险。' },
                    { icon: 'ri-heart-line', title: '核心价值观', desc: '以用户需求为导向，坚持内容质量与安全的双重标准，持续优化服务体验。' },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="bg-background-900 border border-background-800/60 rounded-2xl p-6 md:p-7"
                    >
                      <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mb-4">
                        <i className={`${item.icon} text-xl text-accent-400`}></i>
                      </div>
                      <h3 className="text-sm font-semibold text-foreground-100 mb-2">{item.title}</h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                    </div>
                  ))}
                </div>

                <div className="mb-14 md:mb-20">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-8 text-center">
                    我们的优势
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
                    {[
                      { icon: 'ri-shield-check-line', title: '严格审核', desc: '所有收录网站均经过人工审核，确保内容合法合规，用户访问安全无忧。我们建立了完善的质量评估体系，定期对已收录网站进行复审。' },
                      { icon: 'ri-stack-line', title: '分类齐全', desc: '涵盖视频、直播、图片、社区、小说、交友、游戏、工具等八大类别，满足用户多样化的内容需求。每个分类下都有精心筛选的优质资源。' },
                      { icon: 'ri-speed-up-line', title: '极速导航', desc: '采用智能路由优化技术，确保用户一键直达目标网站，享受流畅的访问体验。持续优化网站性能，减少加载等待时间。' },
                      { icon: 'ri-refresh-line', title: '持续更新', desc: '编辑团队每日更新网站资源，及时添加新涌现的优质平台，剔除失效和低质网站。确保导航信息的时效性和准确性。' },
                    ].map((item, idx) => (
                      <div key={idx} className="flex gap-4 p-5 bg-background-900 border border-background-800/60 rounded-2xl">
                        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 mt-1">
                          <i className={`${item.icon} text-xl text-primary-400`}></i>
                        </div>
                        <div>
                          <h3 className="text-sm font-semibold text-foreground-100 mb-2">{item.title}</h3>
                          <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-14 md:mb-20">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3 text-center">
                    用户口碑
                  </h2>
                  <p className="text-sm text-foreground-500 text-center mb-8">
                    听听用户怎么说
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {[
                      { name: '张先生', text: '成人导航是我用过最好用的导航平台，分类清晰，推荐的网站质量都很高，每天都会来逛逛看看有没有新资源。强烈推荐给需要的朋友！', rating: 5 },
                      { name: '李先生', text: '用了大半年了，确实靠谱。网站更新很及时，基本上我想找的类型都能在这里找到。页面设计也很舒服，响应速度很快。', rating: 5 },
                      { name: '王先生', text: '作为一个不太会找资源的新手，成人导航帮了我大忙。分类导航很清楚，而且推荐的网站确实都是精选过的，不会踩雷。', rating: 5 },
                    ].map((review, idx) => (
                      <div key={idx} className="bg-background-900 border border-background-800/60 rounded-2xl p-5 md:p-6">
                        <div className="flex items-center gap-1 mb-3">
                          {Array.from({ length: review.rating }).map((_, i) => (
                            <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                          ))}
                        </div>
                        <p className="text-xs text-foreground-400 leading-relaxed mb-4">{review.text}</p>
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center">
                            <span className="text-xs text-foreground-400 font-semibold">{review.name[0]}</span>
                          </div>
                          <span className="text-xs text-foreground-500">{review.name}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3 text-center">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-500 text-center mb-8">
                    有任何问题或建议？欢迎通过以下方式联系我们
                  </p>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div className="space-y-4">
                      <div className="flex items-center gap-3 p-4 bg-background-900 border border-background-800/60 rounded-xl">
                        <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-mail-line text-lg text-primary-400"></i>
                        </div>
                        <div>
                          <h4 className="text-sm font-medium text-foreground-200">电子邮箱</h4>
                          <p className="text-xs text-foreground-500">contact@example.com</p>
                        </div>
                      </div>

                      <div className="flex items-center gap-3 p-4 bg-background-900 border border-background-800/60 rounded-xl">
                        <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-time-line text-lg text-accent-400"></i>
                        </div>
                        <div>
                          <h4 className="text-sm font-medium text-foreground-200">工作时间</h4>
                          <p className="text-xs text-foreground-500">周一至周日 09:00 - 22:00</p>
                        </div>
                      </div>

                      <div className="flex items-center gap-3 p-4 bg-background-900 border border-background-800/60 rounded-xl">
                        <div className="w-10 h-10 rounded-lg bg-secondary-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-information-line text-lg text-secondary-400"></i>
                        </div>
                        <div>
                          <h4 className="text-sm font-medium text-foreground-200">合作与建议</h4>
                          <p className="text-xs text-foreground-500">欢迎优质成人平台与我们合作</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-background-900 border border-background-800/60 rounded-2xl p-5 md:p-6">
                      <h3 className="text-sm font-semibold text-foreground-200 mb-4">发送消息</h3>
                      <form
                        id={FORM_ID}
                        data-readdy-form
                        action="https://readdy.ai/api/form/d9q853cnlsngrm4llt70"
                        method="POST"
                        onSubmit={async (e) => {
                          e.preventDefault();
                          const form = e.currentTarget;
                          const formData = new FormData(form);

                          const honeypot = (form.querySelector('input[name="company_alt"]') as HTMLInputElement)?.value?.trim();
                          const statusEl = document.getElementById('form-status');
                          if (honeypot) {
                            if (statusEl) {
                              statusEl.textContent = '消息已发送，我们会尽快回复！';
                              statusEl.className = 'text-xs text-accent-400 mt-3 text-center';
                            }
                            form.reset();
                            return;
                          }

                          try {
                            const res = await fetch(form.action, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                              body: new URLSearchParams(
                                Array.from(formData.entries()).filter(([k]) => k !== 'company_alt').map(([k, v]) => [k, v.toString()])
                              ).toString(),
                            });
                            const text = await res.text();
                            let parsed: Record<string, unknown> = {};
                            try { parsed = JSON.parse(text); } catch { /* ignore */ }
                            const code = typeof parsed?.code === 'string' ? parsed.code : '';
                            const msg = typeof parsed?.meta?.message === 'string' ? parsed.meta.message : '';

                            if (res.ok && code === 'OK') {
                              if (statusEl) {
                                statusEl.textContent = '消息已发送，我们会尽快回复！';
                                statusEl.className = 'text-xs text-accent-400 mt-3 text-center';
                              }
                              form.reset();
                            } else {
                              if (statusEl) {
                                statusEl.textContent = msg || '发送失败，请稍后再试';
                                statusEl.className = 'text-xs text-red-400 mt-3 text-center';
                              }
                            }
                          } catch {
                            if (statusEl) {
                              statusEl.textContent = '网络错误，请检查连接后重试';
                              statusEl.className = 'text-xs text-red-400 mt-3 text-center';
                            }
                          }
                        }}
                      >
                        <div className="space-y-4">
                          <div>
                            <label htmlFor="contact-name" className="text-xs text-foreground-400 mb-1.5 block">姓名</label>
                            <input
                              id="contact-name"
                              name="name"
                              type="text"
                              required
                              placeholder="请输入您的姓名"
                              className="w-full px-4 py-2.5 bg-background-800 border border-background-700/60 rounded-lg text-sm text-foreground-100 placeholder-foreground-600 outline-none focus:border-primary-500/50 transition-colors"
                            />
                          </div>
                          <div>
                            <label htmlFor="contact-email" className="text-xs text-foreground-400 mb-1.5 block">邮箱</label>
                            <input
                              id="contact-email"
                              name="email"
                              type="email"
                              required
                              placeholder="请输入您的邮箱"
                              className="w-full px-4 py-2.5 bg-background-800 border border-background-700/60 rounded-lg text-sm text-foreground-100 placeholder-foreground-600 outline-none focus:border-primary-500/50 transition-colors"
                            />
                          </div>
                          <div>
                            <label htmlFor="contact-message" className="text-xs text-foreground-400 mb-1.5 block">消息内容</label>
                            <textarea
                              id="contact-message"
                              name="message"
                              required
                              maxLength={500}
                              rows={4}
                              placeholder="请输入您的消息（最多500字）"
                              className="w-full px-4 py-2.5 bg-background-800 border border-background-700/60 rounded-lg text-sm text-foreground-100 placeholder-foreground-600 outline-none focus:border-primary-500/50 transition-colors resize-none"
                            ></textarea>
                          </div>

                          <input
                            type="text"
                            name="company_alt"
                            className="antispam-field"
                            tabIndex={-1}
                            autoComplete="off"
                            aria-hidden="true"
                            readOnly
                          />

                          <button
                            type="submit"
                            className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
                          >
                            发送消息
                          </button>
                        </div>
                        <div id="form-status" className="mt-3"></div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}